// Currency constants for Pakistani Rupee
export const CURRENCY_SYMBOLS = {
  PKR: 'Rs',
  USD: '$',
  EUR: '€',
  GBP: '£',
  INR: '₹',
} as const

export const CURRENCY_CODES = {
  PAKISTANI_RUPEE: 'PKR',
  US_DOLLAR: 'USD',
  EURO: 'EUR',
  BRITISH_POUND: 'GBP',
  INDIAN_RUPEE: 'INR',
} as const

// Default currency for Pakistani context
export const DEFAULT_CURRENCY = CURRENCY_CODES.PAKISTANI_RUPEE
export const DEFAULT_CURRENCY_SYMBOL = CURRENCY_SYMBOLS.PKR

// Currency formatting helper
export const formatCurrency = (
  value: number,
  currency: string = DEFAULT_CURRENCY,
): string => {
  if (value === undefined || value === null) {
    return '--'
  }

  const symbol =
    CURRENCY_SYMBOLS[currency as keyof typeof CURRENCY_SYMBOLS] ||
    CURRENCY_SYMBOLS.PKR
  return `${symbol}${value.toLocaleString()}`
}
